import AcceptCookiesManager from "@web/vpt-assets/assets/js/utilities/cookies/acceptCookiesManager";
import LoginDataLayerGenerator from "./dataLayer/loginDataLayerGenerator";
import DataLayerManager from "./dataLayer/dataLayerManager";
import {onCLS, onINP, onLCP} from 'web-vitals/attribution';

export default class TrackersManager {
    constructor() {
        let googleTagManagerScript = document.querySelector('[data-entity="google-tag-manager-script"]');
        if (!googleTagManagerScript || typeof googleTagManagerScript === 'undefined' || !myApp.config.parameters.googleTagManagerKey) {
            return;
        }
        this.dataLayerManager = new DataLayerManager();
        let today = new Date().getTime();

        this.alwaysEnabled = myApp.config.parameters.isOffice || (today >= new Date("2024-09-14 00:00:00").getTime() && today <= new Date("2024-09-15 23:59:00").getTime());
        this.bypassDates = [
            { start: '2025-05-31T00:00:00', end: '2025-06-01T23:59:59' },
            { start: '2025-06-07T00:00:00', end: '2025-06-08T23:59:59' },
            { start: '2025-07-05T00:00:00', end: '2025-07-06T23:59:59' },
            { start: '2025-07-12T00:00:00', end: '2025-07-13T23:59:59' },
            { start: '2025-07-19T00:00:00', end: '2025-07-20T23:59:59' },
            { start: '2025-08-09T00:00:00', end: '2025-08-10T23:59:59' },
            { start: '2025-09-06T00:00:00', end: '2025-09-07T23:59:59' },
            { start: '2025-09-13T00:00:00', end: '2025-09-14T23:59:59' }
        ];
        this.bypassUserPreference = this.bypassDates.some(dateRange => {
            const start = new Date(dateRange.start).getTime();
            const end = new Date(dateRange.end).getTime();
            return today >= start && today <= end;
        });
        this.acceptCookiesManager = new AcceptCookiesManager('cookies-accept', this.alwaysEnabled, this.bypassUserPreference);

        this.updateCookieConsent();
        this.initializeDataLayers();
        this.eventDelegation();
        if (Math.random() <= 0.10) {
            onCLS(this._sendToGoogleAnalytics.bind(this));
            onINP(this._sendToGoogleAnalytics.bind(this));
            onLCP(this._sendToGoogleAnalytics.bind(this));
        }
    }

    eventDelegation() {
        document.querySelector('[data-entity="google-tag-manager-script"]').addEventListener(AcceptCookiesManager.onLoadEvent, () => {
            this.updateCookieConsent();
            this.dataLayerManager.pushData(JSON.stringify({
                'event': 'cookie_consent_click',
                'event_detail_1': this.acceptCookiesManager.cookiesStatus
            }));
        });
    }

    updateCookieConsent() {
        if (!this.acceptCookiesManager.cookiesStatus) {
            return;
        }

        function gtag() {
            if (typeof dataLayer != 'undefined') {
                dataLayer.push(arguments);
            }
        }

        gtag('consent', 'update', {
            ad_user_data: this.acceptCookiesManager.cookiesStatus,
            ad_personalization: this.acceptCookiesManager.cookiesStatus,
            ad_storage: this.acceptCookiesManager.cookiesStatus,
            analytics_storage: this.acceptCookiesManager.cookiesStatus
        });
        this.dataLayerManager.pushData(JSON.stringify({
            'event': 'cookie_consent_update',
            'event_detail_1': this.acceptCookiesManager.cookiesStatus
        }));
    }

    initializeDataLayers() {
        new LoginDataLayerGenerator();

        if (myApp.purchaseDataLayer) {
            this.dataLayerManager.pushData(myApp.purchaseDataLayer);
            this.dataLayerManager.push(DataLayerManager.prototype.type_client);
        }
        if (myApp.enhancedConversionDataLayer) {
            this.dataLayerManager.pushData(myApp.enhancedConversionDataLayer);
        }
        if (myApp.refundDataLayer) {
            this.dataLayerManager.pushData(myApp.refundDataLayer);
        }
        if (myApp.checkoutDataLayer) {
            this.dataLayerManager.pushData(myApp.checkoutDataLayer);
        }
        if (typeof dataLayers !== 'undefined') {
            dataLayers.forEach((dataLayer) => {
                this.dataLayerManager.pushData(JSON.stringify(dataLayer));
            });
        }
        $('[data-events]').on('click', (event) => {
            let currentTarget = $(event.currentTarget);
            let events = currentTarget.data('events');
            this.generate(events);
        });
    }

    generate(events) {
        Object.keys(events).forEach((k) => events[k] == null && delete events[k]);
        this.dataLayerManager.pushData(JSON.stringify(events));
    }

    _sendToGoogleAnalytics({name, delta, value, id, entries, rating, attribution}) {
        let debugTarget = attribution ? attribution.largestShiftTarget || attribution.target || attribution.eventTarget || '' : '(not set)';
        switch (name) {
            case 'CLS':
                debugTarget = attribution.largestShiftTarget;
                break;
            case 'INP':
                debugTarget = attribution.interactionTarget;
                break;
            case 'LCP':
                debugTarget = attribution.target;
                break;
        }

        let data = {
            event: 'coreWebVitals',
            webVitalsMeasurement: {
                metric_id: id,
                metric_name: name,
                metric_value: value,
                metric_delta: delta,
                metric_rating: rating,
                debug_target: debugTarget,
                debug_event_type: attribution ? attribution.eventType || '' : '',
                debug_timing: attribution ? attribution.loadState || '' : '',
                event_time: attribution ? attribution.largestShiftTime || (attribution.lcpEntry && attribution.lcpEntry.startTime) || attribution.eventTime || '' : '',
                path: window.location.pathname.split('/').slice(0, 3).join('/'),
            }
        };

        this.dataLayerManager.pushData(JSON.stringify(data));
    }
}
